import { atom, useAtom } from 'jotai';

import { TurnaroundEntity } from '../models';

const turnaroundDestinationSelectedEntities = atom<Array<TurnaroundEntity>>([]);

export const useTurnaroundDestinationSelectedEntities = () => useAtom(turnaroundDestinationSelectedEntities);
